import React from 'react'

interface SalesQuantityIconProps {
  color?: string
  size?: number | string
  className?: string
}

export const SalesQuantityIcon: React.FC<SalesQuantityIconProps> = ({
  color = 'currentColor',
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* List/document with numbers */}
    <path
      d="M9 5H20M9 9H20M9 13H20M9 17H20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    {/* Number indicators */}
    <circle cx="4" cy="5" r="1.5" fill={color} />
    <circle cx="4" cy="9" r="1.5" fill={color} />
    <circle cx="4" cy="13" r="1.5" fill={color} />
    <circle cx="4" cy="17" r="1.5" fill={color} />
    {/* Document outline */}
    <path
      d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
  </svg>
)

export default SalesQuantityIcon
